import { collection, doc, onSnapshot, query, where } from "firebase/firestore";
import { createContext, useContext, useEffect, useState } from "react";
import { auth, db } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";

const userDataContext = createContext();

export function UserDataContextProvider({ children }) {
    const [userData, setUserData] = useState({});
    const [user, setUser] = useState(null)
    const publisherID = localStorage.getItem("publisherID");


    useEffect(() => {
        const unsubsribe = onAuthStateChanged(auth, async (currentUser) => {
            if (currentUser) {
                setUser(currentUser);
            } else {
                setUser(null);
            }
        });

        return () => {
            unsubsribe();
        };
    }, []);


    useEffect(() => {
        if (user) {
            const pubID = user.uid;
            const unsubsribe = onSnapshot(doc(db, "publishers", pubID), (doc) => {
                if (doc.exists()) {
                    setUserData(doc.data())
                }
            });
            return () => {
                unsubsribe()
            }
        }

    }, [user])

    return (
        <userDataContext.Provider value={{ userData }}>
            {children}
        </userDataContext.Provider>
    )
}

export function useUserData() {
    return useContext(userDataContext)
}
